/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable max-len */
// this code has been worked on other platform, and refactoring may cause other problem so keeps as is.
namespace MsftSme {
    'use strict';

    const global: any = window;
    const FunctionGlobal = Function;
    const MathGlobal = Math;
    const ObjectGlobal = Object;

    // See Mark Miller’s explanation of what this does.
    // http://wiki.ecmascript.org/doku.php?id=conventions:safe_meta_programming
    //
    // For example:
    // const array_slice: <T>(target: T[]|IArguments, start?: number, end?: number) => T[] = MsPortalFx.uncurryThis(Array.prototype.slice);
    // Then the call can be strong typed, rather than call/apply with only runtime check.
    //
    // This also **might** have the nice side-effect of reducing the size of
    // the minified code by reducing x.call() to merely x()
    const call = FunctionGlobal.call;
    const apply = FunctionGlobal.apply;
    export function uncurryThis(f: (...args: any[]) => any): (...args: any[]) => any {
        return function () {
            return call.apply(f, arguments);
        };
    }

    const _applyCall: (f: (...args: any[]) => any, target: any, args: any[] | IArguments) => any = uncurryThis(apply);
    export const applyCall = _applyCall;
    export const applyUncurry = _applyCall; // most uncurry function can be call by _applyCall  except for array_concat; (see below.)

    // declare variable such that  minimize better and code readibility
    const array_prototype = Array.prototype;
    const array_prototype_concat = array_prototype.concat; // array concat does not work well with uncurryThis since it flatten the arguments array.
    const array_prototype_push = array_prototype.push;
    const array_filter: <T>(target: T[] | IArguments, callbackfn: (value: T, index: number, array: T[]) => boolean, thisArg?: any) => T[] = uncurryThis(array_prototype.filter);
    const array_forEach: <T>(target: T[] | IArguments, callbackfn: (value: T, index: number, array: T[]) => void, thisArg?: any) => void = uncurryThis(array_prototype.forEach);
    const array_join: <T>(target: T[] | IArguments, separator?: string) => string = uncurryThis(array_prototype.join);
    const array_push: <T>(target: T[] | IArguments, item: T) => number = uncurryThis(array_prototype_push);
    const array_slice: <T>(target: T[] | IArguments, start?: number, end?: number) => T[] = uncurryThis(array_prototype.slice);
    const array_splice: <T>(target: T[] | IArguments, start: number, deleteCount?: number, ...items: T[]) => T[] = uncurryThis(array_prototype.splice);
    // eslint-disable-next-line unused-imports/no-unused-vars
    const array_indexof: <T>(target: T[] | IArguments, searchElement: T, fromIndex?: number) => number = uncurryThis(array_prototype.indexOf);

    const array_isArray = Array.isArray;

    const string_prototype = String.prototype;
    const string_concat: (target: string, ...items: string[]) => string = uncurryThis(string_prototype.concat);
    const string_split: (target: string, separator: string, limit?: number) => string[] = uncurryThis(string_prototype.split);
    const string_substring: (target: string, start: number, end?: number) => string = uncurryThis(string_prototype.substring);
    const string_indexOf: (target: string, searchString: string, position?: number) => number = uncurryThis(string_prototype.indexOf);
    const string_toLowerCase: (target: string) => string = uncurryThis(string_prototype.toLowerCase);

    const object_hasOwnProperty: (target: Object, v: string) => boolean = uncurryThis(ObjectGlobal.prototype.hasOwnProperty);
    const object_propertyIsEnumerable: (target: Object, v: PropertyKey) => boolean = uncurryThis(ObjectGlobal.prototype.propertyIsEnumerable);
    const object_keys_original = ObjectGlobal.keys;
    const _undefined: any = undefined;

    const object_freeze = ObjectGlobal.freeze;

    const functionType = "function";
    const stringType = "string";
    const numberType = "number";
    const objectType = "object";
    const undefinedType = "undefined";

    export class LocalStorageHandler {
        /**
         * Gets the local storage.
         * @param window the window object to get local storage from.
         * @returns The local storage.
         */
        public static getLocalStorage(window?: Window): Storage  {
            try {
                return window ? window.localStorage : localStorage;
            } catch (error) {
                console.warn('Error getting the localStorage:', error);
            }
        }

        /**
         * Sets the value for the localStorage by key.
         * @param key The key to set value.
         * @param value The value for the key.
         */
        public static setItem(key: string, value: string, window?: Window): void {
            try {
                const localStorageTarget = window ? window.localStorage : localStorage;
                localStorageTarget.setItem(key, value);
            } catch (error) {
                console.warn('Error saving to localStorage:', error);
            }
        }

        /**
         * Gets the value from localStorage by key.
         * @param key The key to get value.
         * @returns The value for the key passed in.
         */
        public static getItem(key: string, window?: Window): string {
            try {
                const localStorageTarget = window ? window.localStorage : localStorage;
                return localStorageTarget.getItem(key);
            } catch (error) {
                console.warn('Error retrieving from localStorage:', error);
            }

            return undefined;
        }

        /**
         * Removes the value for the localStorage by key.
         * @param key The key to remove value.
         */
        public static removeItem(key: string, window?: Window): void {
            try {
                const localStorageTarget = window ? window.localStorage : localStorage;
                localStorageTarget.removeItem(key);
            } catch (error) {
                console.warn('Error removing from localStorage:', error);
            }
        }

        /**
         * Clears the current localStorage.
         */
        public static clear(window?: Window): void {
            try {
                const localStorageTarget = window ? window.localStorage : localStorage;
                localStorageTarget.clear();
            } catch (error) {
                console.warn('Error clearing localStorage:', error);
            }
        }

        /**
         * Gets the length of the local storage
         */
        public static getLength(window?: Window): number {
            let length: number;
            try {
                const localStorageTarget = window ? window.localStorage : localStorage;
                length = localStorageTarget.length;
            } catch (error) {
                console.warn('Error getting localStorage length:', error);
            }

            return length;
        }

        /*
        * Gets the key by index.
        */
        public static getKey(index: number, window?: Window): string {
            let value: string;
            try {
                const localStorageTarget = window ? window.localStorage : localStorage;
                value = localStorageTarget.key(index);
            } catch (error) {
                console.warn('Error getting value from localStorage by key:', error);
            }

            return value;
        }
    }

    export class SessionStorageHandler {
        /**
         * Gets the session storage.
         * @returns The session storage.
         */
        public static getSessionStorage(): Storage {
            try {
                return sessionStorage;
            } catch (error) {
                console.warn('Error getting the sessionStorage:', error);
            }
        }

        /**
         * Sets the value for the sessionStorage by key.
         * @param key The key to set value.
         * @param value The value for the key.
         */
        public static setItem(key: string, value: string): void {
            try {
                SessionStorageHandler.getSessionStorage().setItem(key, value);
            } catch (error) {
                console.warn('Error saving to sessionStorage:', error);
            }
        }

        /**
         * Gets the value from sessionStorage by key.
         * @param sessionStorageTarget The sessionStorage to use.
         * @param key The key to get value.
         * @returns The value for the key passed in.
         */
        public static getItem(key: string): string {
            try {
                return SessionStorageHandler.getSessionStorage().getItem(key);
            } catch (error) {
                console.warn('Error retrieving from sessionStorage:', error);
            }

            return '{}';
        }

        /**
         * Removes the value for the sessionStorage by key.
         * @param sessionStorageTarget The sessionStorage to use.
         * @param key The key to remove value.
         */
        public static removeItem(key: string): void {
            try {
                SessionStorageHandler.getSessionStorage().removeItem(key);
            } catch (error) {
                console.warn('Error removing from sessionStorage:', error);
            }
        }

        /**
         * Clears the current sessionStorage.
         * @param sessionStorageTarget The sessionStorage to use.
         */
        public static clear(): void {
            try {
                SessionStorageHandler.getSessionStorage().clear();
            } catch (error) {
                console.warn('Error clearing sessionStorage:', error);
            }
        }

        /**
         * Gets the length of the sessionStorage
         * @param sessionStorageTarget The sessionStorage to use.
         * @returns
         */
        public static getLength(): number {
            let length: number;
            try {
                length = SessionStorageHandler.getSessionStorage().length;
            } catch (error) {
                console.warn('Error getting sessionStorage length:', error);
            }

            return length;
        }

        /* Gets the key by index.
        * @param sessionStorageTarget The sessionStorage to use.
        * @returns
        */
        public static getKey(index: number): string {
            let value: string;
            try {
                value = SessionStorageHandler.getSessionStorage().key(index);
            } catch (error) {
                console.warn('Error getting value from sessionStorage by key:', error);
            }

            return value;
        }
    }

    /**
     * For testing only. Use Object.keys.
     */
    export function _objectKeysPolyfill(o: any) {
        switch (typeof o) {
            case stringType:
                const arr: string[] = [];
                for (let i in o) {
                    array_push(arr, i);
                }
                return arr;
            case functionType:
            case objectType:
            case undefinedType:
                return object_keys_original(o);
            default: // probably some other native type
                return [];
        }
    }

    // intentionally put inside an anonymous function.
    // Presence of try-catch impacts the browser's ability
    // to optimize code in the same function context.
    (() => {
        try {
            object_keys_original("");
        } catch (err) {
            // it threw so this browser is in ES5 mode (probably IE11)
            // let's polyfill Object.keys
            ObjectGlobal.keys = _objectKeysPolyfill;
        }
    })();

    const object_keys = ObjectGlobal.keys;

    function isTypeOf(obj: any, type: string) {
        return typeof obj === type;
    }

    function isDate(obj: any) {
        return obj instanceof Date;
    }

    export function isFunction(obj: any): boolean {
        return isTypeOf(obj, functionType);
    }

    export function isNumber(obj: any): boolean {
        return isTypeOf(obj, numberType);
    }

    const regex_NonSpace = /\S/;
    const regex_WhiteSpace = /\s/;

    function getDisposeFunc(value: any): Func<void> {
        let dispose = value && value.dispose;
        return isTypeOf(dispose, functionType) && dispose;
    }

    export function forEachKey<T>(obj: StringMap<T>, iterator: (key: string, value: T) => void): void;
    export function forEachKey<T>(obj: NumberMap<T>, iterator: (key: number, value: T) => void): void;
    export function forEachKey<T>(obj: any, iterator: (key: any, value: T) => void): void {
        array_forEach(object_keys(obj), (k) => {
            iterator(k, obj[k]);
        });
    }

    /**
     * Shortcut for Object.keys(obj || {}).length.
     * @return number.
     */
    export function keysLength(obj: Object) {
        return object_keys(obj || {}).length;
    }

    /**
     * Determines whether an object has properties on it.
     * Will return true for the following inputs: [], {}, "", 0, 1, true, false, new Date(), function() {}.
     * Will return false for the following inputs: [1], {a:1}, "123".
     * @return boolean.
     */
    export function isEmpty(obj: Object) {
        return !keysLength(obj);
    }

    /**
     * Detect a value is Disposable.
     *
     * @param value The value to check against value.dispose is a function.
     * @return boolean.
     */
    export function isDisposable(value: any): boolean {
        return !!getDisposeFunc(value);
    }

    function _disposeDisposable(value: any): void {
        if (array_isArray(value)) {
            array_forEach(value, _disposeDisposable);
        }

        const dispose = getDisposeFunc(value);
        if (dispose) {
            dispose.call(value); //  dispose typically rely on this is the object.
        }
    }

    /**
     * call value.dispose() if a value is Disposable.
     *
     * @param value The value to call value.dispose()
     * @return boolean;
     */
    export const disposeDisposable: (...values: any[]) => void = function (/*...values: any[]*/) {
        array_forEach(arguments, _disposeDisposable);
    };

    /**
     * Detect a value is null.
     *
     * @param value The value to check against null.
     * @return boolean.
     */
    export function isNull(value: any): boolean {
        return value === null;
    }

    /**
     * Detect a value is undefined.
     *
     * @param value The value to check against undefined.
     * @return boolean.
     */
    export function isUndefined(value: any): boolean {
        return value === _undefined;
    }

    /**
     * Indicates whether the specified object is null or undefined.
     *
     * @param value The value to test.
     * @returns True if the value parameter is null or undefined; otherwise, false.
     */
    export function isNullOrUndefined(value: any): boolean {
        return value === null || value === _undefined;
    }

    /**
     * Indicates whether the specified object is not null or undefined.
     *
     * @param value The value to test.
     * @returns True if the value parameter is null or undefined; otherwise, false.
     */
    export function notNullOrUndefined(value: any): boolean {
        return value !== null && value !== _undefined;
    }

    /**
     * Checks if the string is null, undefined or whitespace.
     *
     * @param  value The target string.
     * @return true if the string is null, undefined or whitespace; otherwise, false.
     */
    export function isNullOrWhiteSpace(value: string): boolean {
        // http://jsperf.com/empty-string-test-regex-vs-trim/4
        return isNullOrUndefined(value) || (isTypeOf(value, stringType) && !regex_NonSpace.test(value)); // if can't find any characters other than space.
    }

    /**
     * Checks if a string contains a white space
     *
     * Space, tab, line feed (newline), carriage return, form feed, and vertical tab characters are all
     * considered white space characters - https://learn.microsoft.com/en-us/cpp/c-language/white-space-characters?view=msvc-170
     * @param value the target string
     * @returns true if string contains a white space character else false
     */
    export function containsWhiteSpace(value: string): boolean {
        return regex_WhiteSpace.test(value);
    }

    //#region Array

    /**
     * Finds the index of the first element of an array that matches the predicate.
     *
     * @param predicate The Predicate function.
     * @param startIndex The starting index.  If negative, it find from the end of the array.
     *        If you want to continue the next search from the back you much pass in startIndex = (prevReturn - length -1)
     *
     * @return The first index that matches the predicate.
     */
    export function findIndex<T>(array: T[], predicate?: (value: T, index: number, array: T[]) => boolean, startIndex: number = 0): number {
        if (array) {
            let length = array.length;
            let stop = length;
            let step = 1;
            let index = startIndex;

            if (length) {
                if (startIndex < 0) {
                    index += length;
                    step = stop = -1;
                }
                if (!predicate) {
                    return index < length && index >= 0 ? index : -1;
                }
                while (index !== stop) {
                    if (predicate(array[index], index, array)) {
                        return index;
                    }
                    index += step;
                }
            }
        }

        return -1;
    }

    /**
     * Finds the first element of an array that matches the predicate.
     *
     * @param predicate The Predicate function.
     * @param startIndex The starting index.  If negative, it find from the end of the array.
     *        If you want to continue the next search from the back you much pass in startIndex = (prevReturn - length -1)
     *
     * @return The first element that matches the predicate.
     */
    export function find<T>(array: T[], predicate?: (value: T, index: number, array: T[]) => boolean, startIndex?: number): T {
        const index = findIndex(array, predicate, startIndex);
        return index < 0 ? _undefined : array[index];
    }

    /**
     * Returns the first element of the sequence.
     *
     * @return The element
     */
    export function first<T>(array: T[]): T {
        return array ? array[0] : _undefined;
    }

    /**
     * Returns the last element of the sequence.
     *
     * @return The element
     */
    export function last<T>(array: T[]): T {
        const length = array ? array.length : 0;
        return length ? array[length - 1] : _undefined;
    }

    /**
     * Removes all values that equal the given item and returns them as an array
     *
     * @param item The value to be removed.
     * @return The removed items.
     */
    export function remove<T>(array: T[], itemOrPredicate: T | ((value: T) => boolean), startIndex: number = 0): T[] {
        const removedItems: T[] = [];
        let removedCount = 0;
        let predicate: (value: T) => boolean;

        if (isTypeOf(itemOrPredicate, functionType)) {
            predicate = <any>itemOrPredicate;
        }
        for (let i = startIndex, l = array.length; i < l; i++) {
            const item = array[i];
            if (removedCount) {
                array[i - removedCount] = item; //shift the item to the offset
            }
            if (itemOrPredicate === item || (predicate && predicate(item))) {
                removedCount++;
                array_push(removedItems, item);
            }
        }

        if (removedCount) {
            array_splice(array, -1 * removedCount); // remove that many item form the end;
        }

        return removedItems;
    }

    // This function use findIndex, put it here for minimizer friendly
    // sourceUnique is a flag to optimize the performance, set to  true if you know source is unique already.
    export function pushUnique<T>(uniqueTarget: T[], source: T[], predicate?: (value1: T, value2: T) => boolean, sourceUnique = false): T[] {
        if (array_isArray(source)) {
            let getIndex = predicate ?
                (value: T) => findIndex(uniqueTarget, (resultValue) => predicate(resultValue, value)) :
                (value: T) => uniqueTarget.indexOf(value);
            let appendTarget = (sourceUnique) ? [] : uniqueTarget; // if source is already unique, we accumlate to a sperated array to increase the perf.
            for (let i = 0, l = source.length; i < l; i++) {
                let value = source[i];
                if (getIndex(value) < 0) {
                    array_push(appendTarget, value);
                }
            }
            if (sourceUnique) { // if source is unique, we append to a uniqueTarget .
                array_prototype_push.apply(uniqueTarget, appendTarget);
            }
        }

        return uniqueTarget;
    }

    /**
     * Returns a unique set from this array based on the predicate.
     *
     * @param predicate The predicate function. Added to the result if the predicate returns false.
     * @return A new array with the unique values.
     */
    export function unique<T>(array: T[], predicate?: (value1: T, value2: T) => boolean): T[] {
        return pushUnique([], array, predicate);
    }

    /**
     * Returns a unique concatenated set from this array and the given array based on the predicate.
     *
     * @param arrays The list of arrays to get union of.
     * @return A new array with the unique values.
     */
    export function union<T>(...arrays: T[][]): T[];

    /**
     * Returns a unique concatenated set from this array and the given array based on the predicate.
     *
     * @param other The other array to concatenate with this one.
     * @param predicate The predicate function. Added to the result if the predicate returns false.
     * @return A new array with the unique values.
     */
    export function union<T>(array: T[], other: T[], predicate?: (value1: T, value2: T) => boolean): T[];
    export function union<T>(): T[] {
        const result: T[] = [];
        let lastArrayIndex = arguments.length - 2;
        let predicate = arguments[lastArrayIndex + 1];

        // If the predicate is not a function, it means that it is the last array to union.
        if (!isTypeOf(predicate, functionType)) {
            predicate = _undefined;
            lastArrayIndex++;
        }

        for (let i = 0; i <= lastArrayIndex; i++) {
            let source = unique(arguments[i], predicate); // make a smaller set
            pushUnique(result, source, predicate, true /* source Unique*/);
        }

        return result;
    }

    /**
     * Merge multiple T, T[] into a combine T[] exclude null or undefined arguments.
     *
     * @param data, a list fo T, T[]
     * @returns concattenated array.
     */
    export const merge: <T>(...data: (T | T[])[]) => T[] = function <T>(/*...data: T[]*/): T[] {
        // Don't use TypeScript's built-in "... rest" args syntax for perf-critical
        // paths because it constructs the args array even if you don't need it,
        let ret: T[] = [];
        let data = array_filter(arguments, notNullOrUndefined);
        return array_prototype_concat.apply(ret, data);
    };

    /**
     * Projects each element of a sequence to a sequence and flattens the resulting sequences into one sequence.
     *
     * @param selector The projection function.
     * @return A flattened array.
     */
    export function mapMany<T, TResult>(array: T[], selector: (source: T) => TResult[]): TResult[] {
        return merge.apply(null, array.map(selector));
    }

    /**
     * Sorts an array using a stable sort algorithm.
     *
     * This method returns a new array, it does not sort in place.
     *
     * @param compare The Compare function.
     * @return Sorted array.
     */
    export function stableSort<T>(array: T[], compare: (a: T, b: T) => number): T[] {
        const array2 = array.map((v, i) => {
            return { i: i, v: v };
        });
        array2.sort((a, b) => {
            return compare(a.v, b.v) || (a.i - b.i);
        });
        return array2.map(v => v.v);
    }

    function toString<T>(item: T): string {
        return item ? item.toString() : String(item);
    }

    /**
     * Extends from  a source array into an existing string map of key => item.
     *
     * @param objToExtend The target object to be extended.
     * @param sourceArray The source array to convert to a map properties of target object.
     * @param getKeyCallback The callback used to provide the key for the item.
     * @param getValueCallback The optional callback used to provide the key for the item, otherwise the item itself is used.
     * @param onlyIfNotExist If true, only Extend the value in array if the existing slot is still undefine. (This behaves like type script argument default value, it only fill in if the value is undefined.)
     *
     * @return The string map of key => item for the source array.
     */
    export function extendArrayIntoMap<T, U>(objToExtend: StringMap<U>, sourceItems: T[], getKeyCallback?: (item: T, index?: number) => string, getValueCallback?: (item: T, index?: number, key?: string) => U, onlyIfNotExist?: boolean): void;
    export function extendArrayIntoMap<T, U>(objToExtend: NumberMap<U>, sourceItems: T[], getKeyCallback?: (item: T, index?: number) => number, getValueCallback?: (item: T, index?: number, key?: string) => U, onlyIfNotExist?: boolean): void;
    export function extendArrayIntoMap<T, U>(objToExtend: any, sourceItems: T[], getKeyCallback?: (item: T, index?: number) => string | number, getValueCallback?: (item: T, index?: number, key?: string) => U, onlyIfNotExist?: boolean): void {
        getKeyCallback = getKeyCallback || toString;
        // The use of args here is to reduce the array creation call and make sure the function context this is the sourceItems.
        let args: any[] = [sourceItems, /*item*/, /*index*/, ""];
        for (let i = 0, l = sourceItems.length; i < l; i++) {
            let item = sourceItems[i];
            args[1] = item;
            args[2] = i;
            args[3] = _undefined;
            let key = call.apply(getKeyCallback, args);
            if (!onlyIfNotExist || objToExtend[key] === _undefined) {
                args[3] = key; // This is convient for the get value function to know the key that previous interpreted by getKeyCallback
                let value = getValueCallback ? call.apply(getValueCallback, args) : item;
                // Only extend this key if the value return is not undefined.
                if (value !== _undefined) {
                    objToExtend[key] = value;
                }
            }
        }
    }

    /**
     * Extends from  a source array into an existing string map of key => item.
     *
     * @param objToExtend The target object to be extended.
     * @param sourceArray The source array to convert to a map properties of target object.
     * @param getKeyCallback The callback used to provide the key for the item.
     * @param getValueCallback The optional callback used to provide the key for the item, otherwise the item itself is used.
     * @param  onlyIfNotExist If true, only Extend the value in array if the existing slot is still undefine. (This behaves like type script argument default value, it only fill in if the value is undefined.)
     *
     * @return The string map of key => item for the source array.
     */
    export function extendStringMapIntoMap<T, U>(objToExtend: StringMap<U>, sourceItems: StringMap<T>, getValueCallback?: (item: T, key?: string) => U, onlyIfNotExist?: boolean): void;
    export function extendStringMapIntoMap<T, U>(objToExtend: any, sourceItems: StringMap<T>, getValueCallback?: (item: T, key?: string) => U, onlyIfNotExist?: boolean): void {
        // The use of args here is to reduce the array creation call and make sure the function context this is the sourceItems.
        let args: any[] = [sourceItems, /*item*/, /*key*/];

        forEachKey(sourceItems, (key, item) => {
            if (!onlyIfNotExist || objToExtend[key] === _undefined) {
                args[1] = item;
                args[2] = key; // This is convient for the get value function to know the key that previous interpreted by getKeyCallback
                let value = getValueCallback ? call.apply(getValueCallback, args) : (item || key);
                // Only extend this key if the value return is not undefined.
                if (value !== _undefined) {
                    objToExtend[key] = value;
                }
            }
        });
    }

    /**
     * Helper function to create a object lightweight constructor
     *
     * @param keys the ordered argument keys
     *
     * @return The function that will return string map base on the arguments index order of keys
     */
    export function getStringMapFunc(...keys: string[]): Func<StringMap<any>>;
    export function getStringMapFunc(keys: string[]): Func<StringMap<any>>;
    export function getStringMapFunc(keys: any): Func<StringMap<any>> {

        if (array_isArray(keys)) {
            // make a copy of keys so that future changes to the input array do not impact the behavior of the returned function.
            keys = array_slice(keys);
        } else {
            keys = arguments;
        }

        return function ( /* arguments*/) {
            // Most people call .hasOwnProperty or .constructor (which it should not)
            // since there is no guarantee that any object return to have those function -Expecially in generic function.
            // http://stackoverflow.com/questions/12017693/why-use-object-prototype-hasownproperty-callmyobj-prop-instead-of-myobj-hasow
            // Unfortunately, this need to be changed.
            let ret: StringMap<any> = {};
            array_forEach(arguments, (value, index) => {
                let key = keys[index];
                if (value !== _undefined) {
                    ret[key] = value;
                }
            });
            return ret;
        };
    }

    /**
     * Helper funciton to create a object lightweight constructor
     *
     * @param keys the ordered argument keys
     *
     * @return The function that will return string map base on the arguments index order of keys
     */
    export function applyStringMapFunc(keys: string[]): Func<StringMap<any>> {
        return getStringMapFunc.apply(_undefined, keys);
    }

    /**
     * Helper funciton to create a object of type NameValue<N, T>
     *
     * @param name name
     * @param value value
     *
     * @return an object of NameValue<N, T>
     */
    export const getNameValue: <N, T>(name: N, value: T) => NameValue<N, T> = <any>getStringMapFunc("name", "value");

    /**
     * Get a list of typeScript Enum into Array
     *
     * @param tsEnumeration The Type script Enum Array
     * @param sort optional whether to sort by enum's value
     * @return all NameValue<string, number>[] for this typeScriptEnum
     */
    export function getEnumArray(tsEnumeration: any, sort?: boolean): NameValue<string, number>[] {
        let retVal: { name: string; value: number }[] = [];

        forEachKey(<StringMap<number>>tsEnumeration, (key, val) => {
            if (isTypeOf(key, stringType) && isTypeOf(val, numberType)) {
                array_push(retVal, getNameValue(key, val));
            }
        });

        return sort ? retVal.sort((a, b) => {
            return a.value - b.value;
        }) : retVal;
    }

    /**
     * Coerce an input into an array if it isn't already one.
     */
    export function makeArray<T>(input: T | T[]): T[] {
        if (!array_isArray(input)) {
            if (isNullOrUndefined(input)) {
                input = [];
            } else {
                input = [<T>input];
            }
        }

        return <T[]>input;
    }

    //#endregion Array

    //#region Date

    /**
     * Checks if given dates are equal.
     *
     * @param left Left hand side date.
     * @param left Right hand side date.
     * @return True if left date is equal to right date.
     */
    export function areEqualDates(left: any, right: any): boolean {
        return isDate(left) && isDate(right) && !(left > right || left < right);
    }

    /**
     * Round down the date.getTime() to seconds
     *
     * @param date.
     * @return the getTime in seconds
     */
    export function toSeconds(date: Date): number {
        // The old function use toString to trim off microseconds to time comparsion for stablesort
        // return new Date(x.toString()).getTime();  --- this is slow:

        // http://jsperf.com/truncating-decimals
        // x = new Date()
        //Wed Feb 17 2016 12:15:39 GMT- 0800(Pacific Standard Time)
        //y = new Date(x.toString()).getTime()
        //1455740139000
        //z = (x.getTime() / 1000) | 0
        //1455740139
        return (date.getTime() / 1000) | 0;
    }

    //#endregion Date

    //#region Math

    const hexCharsLowerCase = string_split("0123456789abcdef", "");

    const hexBytesLower: string[] = [];
    array_forEach(hexCharsLowerCase, (upper) => {
        array_forEach(hexCharsLowerCase, (lower) => {
            array_push(hexBytesLower, upper + lower);
        });
    });

    const sizeOfGuidInBytes = 20;
    const tempUintArray = new Uint8Array(sizeOfGuidInBytes);
    const tempStringArray: string[] = new Array(sizeOfGuidInBytes);

    function applyAndOr(index: number, and: number, or: number) {
        const temp = tempUintArray[index] & and;
        tempUintArray[index] = temp | or;
    }

    ////// TODO: const globalCrypto = <Crypto>(window.crypto || (<any>window).msCrypto);
    const globalCrypto = <RandomSource>(window.crypto || (<any>window).msCrypto);

    // c.f. rfc4122 (UUID version 4 = xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx)
    //  xx  xx  xx  xx  -   xx  xx  -  4x  xx  -   yx  xx  -   xx  xx  xx  xx  xx  xx
    //  00  11  22  33  4   55  66  7  88  99  10  11  12  13  14  15  16  17  18  19
    function newGuidCrypto(): string {
        globalCrypto.getRandomValues(tempUintArray);

        applyAndOr(8, 0x0F, 0x40); // set upper half of the 8th byte to 0x4
        applyAndOr(11, 0x3F, 0x80); // set the two most significant bits of the 11th byte to 10b

        for (let i = 0; i < sizeOfGuidInBytes; i++) {
            tempStringArray[i] = hexBytesLower[tempUintArray[i]];
        }

        tempStringArray[4] = tempStringArray[7] = tempStringArray[10] = tempStringArray[13] = "-";

        return applyUncurry(string_concat, "", tempStringArray);
    }

    /**
     * HelperReturns hex number string.
     *
     * @param len The number of the output string length
     * @return a hexnumber string of length len
     */
    function getRandomHexString(len: number): string[] {
        let tmp: number;
        let ret: string[] = new Array(len);

        // This implementation optimization of speed mimimize the cost of Math.random.
        // equal chance for all number
        while (len) {
            tmp = 4294967296 * MathGlobal.random() | 0;  // get the max integer our of 32 digit.
            let times = 8; // for every random number we can harvest 8 times.
            while (times--) {
                ret[--len] = hexCharsLowerCase[tmp & 0xF]; // fill from the back.
                if (len < 0) {
                    return ret; // we filled all the bucket, return now.
                }
                tmp >>>= 4; // zero fill right shift to ensure return is always positive number.
            }
        }
    }

    function newGuidFallback(): string {
        // c.f. rfc4122 (UUID version 4 = xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx)
        const guid = getRandomHexString(36);
        guid[8] = guid[13] = guid[18] = guid[23] = "-"; // fill in the dash.
        guid[14] = "4"; // set the 4 in the guid.
        // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
        // guid[19] = hexValues[8 + (Math.random() * 4) | 0]; /*clockSequenceHi*/
        guid[19] = hexCharsLowerCase[8 + (hexCharsLowerCase.indexOf(guid[19]) & 0x3)]; // Since guid[19] is already random. reused the numbe by get its index rather than another Math.random call.

        return _applyCall(string_concat, "", guid);
    }

    /**
     * Returns a GUID such as xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx.
     *
     * @return New GUID.
     */
    export const newGuid: () => string = globalCrypto ? newGuidCrypto : newGuidFallback;

    const maxCounter = 0xFFF;

    function toHexString(counter: number) {
        return hexBytesLower[counter >> 4] + hexCharsLowerCase[counter & 0xF];
    }

    export function toHex(str: string) {
        let result = '';
        for (let i = 0; i < str.length; i++) {
            result += str.charCodeAt(i).toString(16);
        }
        return result;
    }

    /**
     * Returns a function that can generate globally unique identifiers.
     * Generates a new guid every 4096 calls and concatenates it with an
     * auto incrementing number.  This maintains a complient GUID 4 format
     * if no prefix is added.
     *
     * @return a globally unique string generating function.
     */
    export function getUniqueIdGenerator(prefix?: string) {
        prefix = prefix ? (prefix + "-") : "";
        // use a range for counter that gives us 3 digits with minimum effort
        let guid = "";
        let counter = maxCounter;

        return () => {
            if (++counter > maxCounter) {
                counter = 0;
            }

            if (!counter) {
                guid = prefix + newGuid().substring(0, 33);
            }

            return guid + toHexString(counter);
        };
    }

    /**
     * Returns a function that can generate unique id under the prefix
     * Concatenates prefix with an auto incrementing number.
     *
     * @return a unique string generating function which return a prefix with auto incrementing number
     */
    export function getIdGenerator(prefix: string) {
        // use two counters and
        // limit the size of the lower counter because
        // toString is expensive for large numbers
        let counterUpper = -1;
        let counterLower = maxCounter;
        let realPrefix = "";

        return () => {
            if (++counterLower > maxCounter) {
                counterLower = 0;
                counterUpper++;
                realPrefix = prefix + counterUpper.toString(16) + "-";
            }

            return realPrefix + toHexString(counterLower);
        };
    }

    /**
     * Returns a globally unique identifier string.
     * Lighter-weight than newGuid.
     *
     * @return a globally unique string.
     */
    export const getUniqueId = getUniqueIdGenerator();

    /**
     * Rounds a number to the specified precision.
     *
     * @param number The number to round.
     * @param precision The precision to round the number to. Defaults to 0.
     * @returns The rounded number.
     */
    export function round(number: number, precision?: number): number {
        precision = MathGlobal.pow(10, precision || 0);
        return MathGlobal.round(Number(number) * precision) / precision;
    }

    /**
     * Truncates a number to the integer part.
     *
     * @param value The number to truncate.
     * @return The integer number.
     */
    export function truncate(value: number): number {
        // Converts to integer by bit operation
        return value | 0;
    }

    /**
     * Returns the result of the boolean exclusive-or operator.
     *
     * @param a First operand.
     * @param b Second operand.
     * @return true if the arguments have different values, false otherwise.
     */
    export function xor(a: boolean, b: boolean): boolean {
        return a ? !b : b;
    }

    /**
     * Returns the result of the bitwise and operator. Required because tslint disables
     * bitwise operators by default.
     *
     * @param a First operand.
     * @param b Second operand.
     * @return numerical result of applying bitwise AND to a & b
     */
    export function applyBitwiseAnd(a: number, b: number): number {
        return a & b;
    }

    /**
     * Returns the result of the bitwise or operator. Required because tslint disables
     * bitwise operators by default.
     *
     * @param a First operand.
     * @param b Second operand.
     * @return numerical result of applying bitwise OR to a & b
     */
    export function applyBitwiseOr(a: number, b: number): number {
        return a | b;
    }

    //#endregion Map

    //#region Number

    /**
     * Generates a random integer between min and max inclusive.
     *
     * @param min The minimum integer result.
     * @param max The maximum integer result.
     * @return A random integer.
     */
    export function random(min: number, max: number): number {
        if (min === _undefined || max === _undefined || min > max) {
            return;
        }

        return MathGlobal.floor(MathGlobal.random() * (max - min + 1)) + min;
    }

    //#endregion Number

    //#region Object
    /**
     * Determines whether an object has a property with the specified name.
     * @param target the object to check.
     * @param v A property name.
     */
    export const hasOwnProperty = object_hasOwnProperty;

    /**
     * Determines whether an object has an enumerable property with the specified name.
     * @param target the object to check.
     * @param v A property name.
     */
    export const propertyIsEnumerable = object_propertyIsEnumerable;

    /**
     * Returns a boolean reflecting whether two scalar values (not object-typed, not array-typed, not function-typed)
     * are equal.  Accounts for the fact that JavaScript Date derives from Object.
     * The caller is responsible for supplying exclusively number-, string- or Date-typed values here.
     *
     * @param left The first scalar value.
     * @param right The second scalar value.
     * @return A boolean reflecting whether the two scalar values are equal.
     */
    export function areEqual<T>(left: T, right: T): boolean {
        return left === right || areEqualDates(left, right);
    }

    /**
     * Verifies that two arrays are equal.
     *
     * @param array1 The array to check.
     * @param array2 The array to compare the first array to.
     * @returns A value indicating whether or not the two arrays are equal.
     */
    export function arrayEquals<T>(array1: T[], array2: T[]): boolean {
        if (array1 === array2) {
            return true;
        } else if (!array1 || !array2) {
            return false;
        } else if (array1.length !== array2.length) {
            return false;
        } else {
            for (let i = 0; i < array1.length; i++) {
                if (array1[i] !== array2[i]) {
                    return false;
                }
            }

            return true;
        }
    }

    export function getTypeOf(x: any): string {
        let typeOfX: string = typeof x;

        if (typeOfX === objectType) {
            if (x === null) {
                typeOfX = "null";
            } else if (array_isArray(x)) {
                typeOfX = "array";
            } else if (isDate(x)) {
                typeOfX = "date";
            }
        }

        return typeOfX;
    }

    /**
    * Checks for deep equality of two object.
    *
    * @param a Object 1
    * @param b Object 2
    * @param mapFunc Optional parameter, used convert value conversion use on the value to compare
    * @return true if both of the object contains the same information; false otherwise;
    */
    // eslint-disable-next-line unused-imports/no-unused-vars
    function deepEqualsMap(a: any, b: any, mapFunc?: (v: any) => any): boolean {
        if (mapFunc) {
            a = mapFunc(a);
            b = mapFunc(b);
        }

        if (a === b) {
            return true;
        } else if (!a || !b) {
            return false;
        }

        let typeofInput = getTypeOf(a);
        if (typeofInput !== getTypeOf(b)) {
            return false;
        }

        switch (typeofInput) {
            case "array":
                const aArray: any[] = <any>a;
                return a.length === b.length &&
                    aArray.every((v, index) => deepEqualsMap(v, b[index], mapFunc));
            case "date":
                return a.getTime() === b.getTime();
            case objectType:
                const keysOfInput = object_keys(a);
                return keysOfInput.length === keysLength(b) &&
                    keysOfInput.every((key) => deepEqualsMap(a[key], b[key], mapFunc));
            default:
                // basic type that failed the === check
                return false;
        }
    }

    /**
     * Checks if a given value is a javascript object or not.
     *
     * @param value Value to test.
     * @return True if value is an object, false otherwise.
     */
    export function isObject(value: any): boolean {
        return typeof value === objectType;
    }

    /**
     * Checks if a given value is a plain object or not.
     *
     * @param value Value to test.
     * @return True if value is an object, false otherwise.
     */
    export function isPlainObject(value: any): boolean {
        return getTypeOf(value) === objectType;
    }

    /**
     * Maps each value of the input object. Values that map to null or undefined are skipped.
     *
     * @param obj Input object whose properties are to be mapped.
     * @param callback Invoked for each property of the object to perform the mapping.
     * @param arg An Optional value that can be passed to callback.
     * @return An array of mapped values.
     */
    export function map<T, U>(obj: StringMap<T>, callback: (item: T, key?: string, arg?: any) => U, arg?: any): U[] {
        let callBackArgs: any = [obj, /*item*/, /*key*/, arg];
        let keys = object_keys(obj);
        let ret = keys.map((key) => {
            callBackArgs[1] = obj[key]; // item;
            callBackArgs[2] = key; // key;
            return call.apply(callback, callBackArgs);
        });
        // Flatten any nested arrays and exclude null, undefined items.
        return merge.apply(null, ret);
    }

    /**
     * Shallow copy from a key/value pairs object.
     *
     * @param to An un-typed object to be populated.
     * @param from An un-typed object with values to populate.
     * @param scopes Scoped down the list for shallowCopy
     */
    export function shallowCopyFromObject(to: Object, from: Object, scopes?: string[]): void {
        // http://jsperf.com/shallowcopyobjects/3
        scopes = scopes || object_keys(from);

        for (let i = 0; i < scopes.length; i++) {
            let key = scopes[i];
            let value = (<any>from)[key];
            if (value !== _undefined) {
                (<any>to)[key] = value;
            }
        }
    }

    /**
     * Merges a property from a destination object from a source object
     * @param dest The destination object
     * @param src The source object
     * @param propName The name of the property to assign
     */
    function deepAssignProperty(dest, src, propName) {
        let value = src[propName];
        // if there is no value, dont assign.
        if (isNullOrUndefined(value)) {
            return;
        }

        if (!isObject(value)) {
            /**
            * If the src prop is not an object then set the destination prop directly.
            */
            dest[propName] = value;
        } else if (isObject(value) && isEmpty(value)) {
            /**
             * If the object has no children prop then set the destination prop directly.
             *
             * Handles a special case of a date object as it cannot be shallow copied in
             * the same major as any other supported type.
             * Shown here: https://github.com/davidmarkclements/rfdc/blob/master/index.js
             */
            if (value instanceof Date) {
                dest[propName] = new Date(value);
            } else {
                // Generic object will be shallow copied as it has no properties.
                dest[propName] = array_isArray(value) ? [...value] : { ...value };
            }
        } else if (isObject(value) && !hasOwnProperty(dest, propName) || (typeof (dest[propName]) !== typeof (value))) {
            /** If the src prop is an object and the prop is not defined, create new object
            * and copy over src.
            *
            * Or if the dest and src prop do not match types,
            * pave over dest with src.
            */

            dest[propName] = deepAssignInternal(array_isArray(value) ? [] : {}, value);
        } else {
            // Otherwise merge to src prop with the dest prop.
            dest[propName] = deepAssignInternal(dest[propName], value);
        }
    }

    /**
     * Internal method for merging one object with another
     * @param dest The destination object
     * @param src The source object
     */
    function deepAssignInternal(dest: any, src: any): any {
        // if the to destination is the same object as the source, save some time by just returning
        if (dest === src) {
            return dest;
        }

        // loop through the src objects properties and merge them deeply to the dest
        for (let propName in src) {
            if (hasOwnProperty(src, propName)) {
                deepAssignProperty(dest, src, propName);
            }
        }

        // loop through the src symbols properties and merge them deeply to the dest
        if (Object.getOwnPropertySymbols) {
            let symbols = Object.getOwnPropertySymbols(src);
            symbols.forEach(symbol => {
                if (propertyIsEnumerable(src, symbol)) {
                    deepAssignProperty(dest, src, symbol);
                }
            });
        }

        // return the destination object
        return dest;
    }

    /**
     * Merges a set of source objects to a destination object. Does not
     * handle objects with circular references.
     *
     * Supported types:
     * - Object
     * - Array
     * - Number
     * - String
     * - null
     * - Date
     *
     * @param dest The destination object
     * @param sources  the source objects
     */
    export function deepAssign(dest: any, ...sources: any[]): any {

        // merge all sources into the dest object in order
        sources.forEach(src => {
            return deepAssignInternal(dest, src || {});
        });
        // return the dest object
        return dest;
    }

    /**
 * Copies a source object with any nested objects. Does not
 * handle objects with circular references.
 * @param dest The source object
 *
 * Supported types:
 * - Object
 * - Array
 * - Number
 * - String
 * - null
 * - Date
 *
 * @return a new object that is a copy of the source object
 */
    export function deepCopy(source: any): any {
        return deepAssign({}, source);
    }

    /**
     * Searches an object for a value at a given path.
     * @param object The object to search in
     * @param path the path to walk
     * @param firstPass internal use, indicates that this is the first pass.
     * @returns the object at the end of the path
     */
    function getValueInternal<T>(object: any, path: string | number, firstPass: boolean): T {
        // return null if either argument is not provided
        if (isNullOrUndefined(object) || isNullOrUndefined(path)) {
            return null;
        }

        // always convert path to string
        let strPath = '' + path;

        // on the first pass, replace delimiters in the object path with *
        if (firstPass) {
            strPath = strPath.replace(/\]\.|\.|\[|\]/g, "*");
        }

        // find the next delimiter
        let index = strPath.indexOf('*');

        // if there are no more delimiters, return the object at the path
        if (index === -1) {
            return object[strPath];
        }

        // split the path at the delimiter. Use the first segment as our next object and the second segment for the remaining path
        let next = strPath.slice(0, index);
        let remainingPath = strPath.slice(index + 1);
        if (object[next] !== undefined && remainingPath.length > 0) {
            // dive in recursively to the next object
            return getValueInternal<T>(object[next], remainingPath, false);
        }

        // we found our target object. Return it
        return object[next];
    }

    /**
     * Searchs an object for a value at a given path.
     * @param object The object to search in
     * @param path the path to walk
     * @returns the object at the end of the path
     */
    export function getValue<T>(object: any, path: string): T {
        // call our internal get value function
        return getValueInternal<T>(object, path, true);
    }

    /**
     * Sets a value in an object at a given path
     * @param object The object to search in
     * @param path the path to walk
     * @param value the value to set at object.path
     * @param firstPass internal use, indicates that this is the first pass.
     * @returns the object at the end of the path
     */
    function setValueInternal<T>(object: any, path: string | number, value: any, firstPass: boolean): T {
        if (isNullOrUndefined(object)) {
            object = {};
        }
        if (isNullOrUndefined(path)) {
            return null;
        }

        // always convert path to string
        let strPath = '' + path;

        // on the first pass, replace delimiters in the object path with *
        if (firstPass) {
            strPath = strPath.replace(/\]\.|\.|\[|\]/g, "*");
        }

        // find the next delimiter
        let index = strPath.indexOf('*');

        // if there are no more delimiters, return the object at the path
        if (index === -1) {
            object[strPath] = value;
            return object;
        }

        // split the path at the delimiter. Use the first segment as our next object and the second segment for the remaining path
        let next = strPath.slice(0, index);
        let remainingPath = strPath.slice(index + 1);
        if (remainingPath.length > 0) {
            // dive in recursively to the next object
            return setValueInternal<T>(object[next], remainingPath, value, false);
        }

        object[next] = value;
        return object;
    }

    /**
     * Sets a value in an object at a given path
     * @param object The object to search in
     * @param path the path to walk
     * @param value the value to set at object.path
     * @returns the object at the end of the path
     */
    export function setValue<T>(object: any, path: string, value: any): T {
        // call our internal get value function
        return setValueInternal<T>(object, path, value, true);
    }

    //#endregion Object

    /**
     * Preserves any existing document selection while performing an action that temporarily changes selection
     * @param action The action to take
     */
    export function preserveDocumentSelection(action: Action): void {
        let selectedRange: Range = null;
        if (document.getSelection().rangeCount > 0) {
            selectedRange = document.getSelection().getRangeAt(0);
        }

        action();

        if (selectedRange) {
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(selectedRange);
        }
    }

    /**
     * Safely puts a value to the clipboard. This should always be called from a user driven context (such as click, keydown, etc...)
     * @param value The value to put on the clipboard
     */
    export function copyToClipboard(value: any): void {
        let stringValue = toString(value);
        const el = document.createElement('textarea');
        el.value = stringValue;
        el.setAttribute('readonly', '');
        el.classList.add('sme-screen-reader');
        preserveDocumentSelection(() => {
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        });
    };

    //#region String

    /**
     * Determines if the current string ends with the given string.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
     * http://jsperf.com/string-prototype-endswith/18
     *
     * @param input The input string.
     * @param searchString The characters to be searched for at the end of this string.
     * @param position Optional. Search within this string as if this string were only this long; defaults to this string's actual length, clamped within the range established by this string's length.
     * @return A value indicating whether or not the input string ends with the search string.
     */
    export function endsWith(input: string, searchString: string, position?: number): boolean {
        if (!isTypeOf(searchString, stringType)) {
            return false;
        }

        input = isNullOrUndefined(input) ? "" : String(input);
        const strLen = input.length;
        if (position === _undefined || position > strLen) {
            position = strLen;
        }
        position -= searchString.length;
        const lastIndex = string_indexOf(input, searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    }

    /**
     * Compares the current string to another string and returns a value indicating their relative ordering.
     *
     * @param input The input string to compare.
     * @param other The value to compare the input string to.
     * @param locales The optional array of locale values that will be passed to localeCompare.
     * @param options The options supported by localeCompare.
     * @return 0, if the strings are equal; a negative number if the current string is ordered before value; a positive non-zero number if the current string is orered after value.
     */
    export function localeCompareIgnoreCase(input: string, other: string, locales?: string | string[], options?: CollatorOptions): number {
        if (isNullOrUndefined(input)) {
            return -1;
        }

        if (!isTypeOf(other, stringType)) {
            return 1;
        }

        // take regional local Id to process.
        locales = locales || MsftSme.self().Resources && MsftSme.self().Resources.localeRegionalId;
        return input.toLocaleLowerCase().localeCompare(other.toLocaleLowerCase(), locales, options);
    }

    /**
     * Repeats the string the specified number of times.
     * @param input The input string.
     * @param count The number of times to repeat the string.
     * @returns The result string.
     *  http://jsperf.com/repeatstring2
     */
    export function repeat(input: string, count: number): string {
        let ret = "";
        count = (count < 0) ? 0 : count;
        while (count--) {
            ret += input;
        }
        return ret;
    }

    /**
     * reverse the string.
     * @param input The input string.
     * @returns The result string.
     */
    export function reverse(input: string) {
        let ret = "";
        let length = input.length;
        while (length) {
            ret += input[--length];
        }
        return ret;
    }

    /**
     * Return a function that will perform join with that separator
     *
     * @returns a function that will join the parts together with the character, for example.
     *   joinPaths = getJoinFunc("/");
     *   joinByDash = getJoinFunc("-");
     *
     *  joinPaths("a", "b", "c") will return  "a/b/c";
     *  joinByDash("a", "b", "c") will return  "a-b-c";
     */
    export function getJoinFunc(sep: string): (...parts: string[]) => string {
        return function (): string {
            return array_join(arguments, sep);
        };
    };

    /**
     * Return a function that will perform quote the input.  (Mimizer helper).
     *
     * @returns a function that will join the parts together with the character(s).
        For example.
            quote = getQuoteFunc("'");
            parenthesis = getQuoteFunc("(", ")");
            poMarker = getQuoteFunc("####");
     *
     * quote("abc") will return "'abc'";
     * parenthesis("abc") will reutrn "(abc)";
     * poMarker("abc") will return "####abc####";
     */
    export function getQuoteFunc(prefix: string, suffix?: string): (input: string) => string {
        prefix = prefix || "";
        suffix = suffix || prefix;

        return function (input: string): string {
            return prefix + input + suffix;
        };
    };

    /**
     * Replaces all instances of a value in a string.
     *
     * @param input The input string.
     * @param searchValue The value to replace.
     * @param replaceValue The value to replace with.
     * @return A new string with all instances of searchValue replaced with replaceValue.
     */
    export function replaceAll(input: string, searchValue: string, replaceValue: string): string {
        return input.replace(new RegExp(regexEscape(searchValue), "g"), replaceValue);
    }

    /**
     * Replaces multiple instances of search values and replacement values in a string.
     *
     * @param input The input string.
     * @param replacementMap A string map where each key represents the string to replace, and that key's value represents the value to replace it with.
     * @return A new string with replacementMap values replaced.
     */
    export function replaceMany(input: string, replacementMap: StringMap<string>): string {
        let escapedMap: StringMap<string> = {},
            hasValuesToReplace = false;

        for (let searchValue in (replacementMap || {})) {
            if (replacementMap.hasOwnProperty(searchValue)) {
                escapedMap[regexEscape(searchValue)] = replacementMap[searchValue];
                hasValuesToReplace = true;
            }
        }

        if (!hasValuesToReplace) {
            return input;
        }

        let regex = new RegExp(object_keys(escapedMap).join("|"), "g");
        return input.replace(regex, (match: string) => replacementMap[match]);
    }

    /**
     * Splits a string into the specified number of parts.
     * Differs from string.split in that it leaves the last part containing the remaining string (with separators in it).
     * string.split truncates the extra parts.
     * @param input The string to be split.
     * @param separator A string that identifies the character or characters to be used as the separator.
     * @param limit A value used to limit the number of elements returned in the array.
     * @return An array of strings whose length is at most the value of limit.
     */
    export function split(input: string, separator: string, limit: number): string[] {
        let retVal: string[] = [];

        if (input && separator && limit) {
            let startIndex = 0;
            let seplength = separator.length;
            let indexOf = 0;

            // reduce the limit by one.
            // we'll only break the string into limit - 1 parts
            // and put the remaining in the last spot.
            limit--;
            while (true) {
                // only one spot left in the array. push remaining string into array and exit.
                // no more separators left. push remaining string into array and exit.
                if (retVal.length >= limit || (indexOf = string_indexOf(input, separator, startIndex)) < 0) {
                    array_push(retVal, string_substring(input, startIndex));
                    break;
                }

                array_push(retVal, string_substring(input, startIndex, indexOf));
                startIndex = indexOf + seplength;
            }
        }

        return retVal;
    }

    /**
     * Determines if the current string starts with the given string.
     * http://jsperf.com/string-startswith/49
     *
     * @param input The input string.
     * @param searchString The characters to be searched for at the start of this string.
     * @param position Optional. The position in this string at which to begin searching for searchString; defaults to 0.
     * @return A value indicating whether or not the input string begins with the search string.
     */
    export function startsWith(input: string, searchString: string, position?: number): boolean {
        input = isNullOrUndefined(input) ? "" : String(input);
        position = (isNullOrUndefined(position) || position < 0) ? 0 : MathGlobal.min(position, input.length);
        return input.lastIndexOf(searchString, position) === position;
    }

    /**
     * Trims all occurrences of the given set of strings off the end of the input.
     */
    export function trimEnd(input: string, ...values: string[]) {
        input = input || "";
        while (input) {
            let match = values.first((value) => {
                return value && endsWith(input, value);
            });

            if (!match) {
                break;
            }

            input = string_substring(input, 0, input.length - match.length);
        }

        return input;
    }

    /**
     * Trims all occurrences of the given set of strings off the start of the input.
     */
    export function trimStart(input: string, ...values: string[]) {
        input = input || "";
        while (input) {
            let match = values.first((value) => {
                return value && startsWith(input, value);
            });

            if (!match) {
                break;
            }

            input = string_substring(input, match.length);
        }

        return input;
    }

    /**
     * Ensures that the given string ends with the suffix provided.
     * If it already does, it just returns the input string.
     * If it does not, then the suffix is appended and the result is returned.
     */
    export function ensureSuffix(input: string, suffix: string) {
        input = input || "";
        if (!endsWith(input, suffix)) {
            input += suffix;
        }

        return input;
    }

    /**
     * Ensures that the given string starts with the prefix provided.
     * If it already does, it just returns the input string.
     * If it does not, then the prefix is applied and the result is returned.
     */
    export function ensurePrefix(input: string, prefix: string) {
        input = input || "";
        if (!startsWith(input, prefix)) {
            input = prefix + input;
        }

        return input;
    }

    /**
     * Joins strings in the components array with the specified separator between them.
     * Ignores empty/falsy entries in the components array.
     * If a leading (or trailing) separator is desired, prefix (or suffix)
     * the array of components with an entry that is a separator.
     */
    export function pathJoin(pathSeparator: string, ...pathComponents: string[]): string;
    export function pathJoin(pathSeparator: string, pathComponents: string[]): string;
    export function pathJoin(pathSeparator: string, pathComponents: any): string {
        if (!array_isArray(pathComponents)) {
            pathComponents = array_slice(arguments, 1);
        }

        let output = "";
        array_forEach(<string[]>(pathComponents || []), (current) => {
            if (!output) { // first entry
                output = current || "";
            } else if (current) { // skip empty entries
                output = trimEnd(output, pathSeparator) + ensurePrefix(current, pathSeparator);
            }
        });

        return output;
    }

    //#endregion String

    //#region Browser

    export function isInternetExplorer() {
        // IE Agent Example:
        // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; .NET CLR 2.0.50727; .NET CLR 3.0.30729; .NET CLR 3.5.30729; rv:11.0) like Gecko"
        const agent = window.navigator.userAgent;
        return agent.indexOf('Trident') > 0;
    }

    export function isEdge() {
        // Microsoft Edge Agent Example:
        // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
        const agent = window.navigator.userAgent;

        // We should be able to reliably detect Microsoft Edge using the useragent, because there isn't any browser out there trying to pretend to be Microsoft Edge.
        return /\bEdge\b/.test(agent);
    }

    /**
     * Returns the windows origin in an manner that is safe for all our supported browsers.
     * IE, for example, returns inconsistent results for window.location.origin
     */
    export function getSafeOrigin(): string {
        let port = window.location.port ? `:${window.location.port}` : '';
        let origin = `${window.location.protocol}//${window.location.hostname}${port}`;
        return origin;
    }

    //#endregion Browser

    //#region Uri

    /**
     * Gets a parameter from the locations query string
     * @param parameterName
     */
    export function getLocationSearchParameter(parameterName: string) {
        let query = decodeURIComponent(window.location.search.substring(1));
        return query
            .split('&')
            .map(p => {
                let kvp = p.split('=');
                return { key: kvp[0], value: kvp[1] };
            })
            .find(p => p.key && p.key.toLowerCase() === parameterName.toLowerCase());
    }

    /**
     * Parse an uri and return the Authority of the uri.
     *
     * @param uri The string of uri.
     * @return Authority of the uri.
     */
    export function getUriAuthority(uri: string, includePort: boolean = true): string {
        // If uri starts with "//" or "https://" or "http://", authority will start after that.
        // Otherwise authority starts from very beginning.
        // Authority will end before one of those characters "?/#" or end of string.
        if (!uri) {
            return uri;
        }

        let index = 0;
        if (startsWith(uri, "//")) {
            uri = string_substring(uri, index + 2);
        } else {
            index = string_indexOf(uri, "://");
            if (index > -1) {
                uri = string_substring(uri, index + 3);
            }
        }

        let endChars = includePort ? /[?#/]/ : /[?#/:]/;
        let endIndex = uri.search(endChars);
        endIndex = endIndex > -1 ? endIndex : uri.length;

        return string_substring(uri, 0, endIndex);
    }

    /**
     * Verify if one Url is subdomain of another Url.
     *
     * @param domain The string of domain.
     * @param subdomain The string of subdomain
     * @return True if subdomain is subdomain of domain.
     */
    export function isSubdomain(domain: string, subdomain: string): boolean {
        if (!domain || !subdomain || domain.length < subdomain.length) {
            return false;
        }

        let lowerCaseDomain = string_toLowerCase(domain);
        let lowerCaseSubdomain = string_toLowerCase(subdomain);

        return (lowerCaseDomain === lowerCaseSubdomain) || endsWith(lowerCaseDomain, "." + lowerCaseSubdomain);
    }

    /**
     * Returns whether the given URI is an absolute URI.
     *
     * @param uri The URI.
     * @return A boolean value indicating whether the URI is absolute.
     */
    export function isUriAbsolute(uri: string): boolean {
        return string_indexOf(uri, "://") !== -1 || startsWith(uri, "//");
    }

    //#endregion Uri

    /**
     * Escapes regular expression special characters -[]/{}()*+?.\^$|
     *
     * @param str The string to escape.
     * @return The escaped string.
     */
    export function regexEscape(str: string): string {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }

    /**
     * No-op function.
     */
    export const noop = function (): void {
    };

    const primitiveTypes: StringMap<boolean> = {};

    array_forEach(["boolean", undefinedType, numberType, stringType, "symbol"], (item) => {
        primitiveTypes[item] = true;
    });

    /**
     * Returns whether the given data is primitive data type.
     * ECMAScript 6 standard defines 6 primitive data types: Boolean, Null, Undefined, Number, String, Symbol(new in ECMAScript 6)
     *
     * @param data The input data.
     * @return A boolean value indicating whether the data is primitive data type.
     */
    export function isPrimitive(data: any): boolean {
        return data === null || typeof data in primitiveTypes;
    }

    /**
     * Applies polyfills as properties to the prototype of the given object.
     * If force is specified the polyfills will overwrite any existing properties.
     */
    export function polyfill(type: { prototype: Object }, fills: Object, force?: boolean) {
        const proto = <any>type.prototype;
        forEachKey(<StringMap<Function>>fills, (funcName, func) => {
            if (force || !proto[funcName]) {
                ObjectGlobal.defineProperty(proto, funcName, {
                    value: func,
                    configurable: true,
                    enumerable: false,
                    writable: true
                });
            }
        });
    }

    const mapSupportedMaxInteger = 50;
    const intToStringMap: string[] = [];
    const stringToIntMap: StringMap<number> = {};

    for (let index = 0; index <= mapSupportedMaxInteger; index++) {
        let strVal = index + "";
        intToStringMap[index] = strVal;
        stringToIntMap[strVal] = index;
    }

    function validateRequiredMaxInteger(requiredMaxInteger: number) {
        if (requiredMaxInteger > mapSupportedMaxInteger) {
            throw new Error("The requiredMaxInteger(" + requiredMaxInteger + ") should be less than " + mapSupportedMaxInteger);
        }

        if (requiredMaxInteger <= 0) {
            throw new Error("The requiredMaxInteger(" + requiredMaxInteger + ") should be greater than zero.");
        }
    }

    /**
     * Get a readonly map that is a faster alternative to cast a string to small and non-negative integers.
     * - Doesn't support negative integer since the performance is significantly decreased for negative integer.
     * - The JSperf links: http://jsperf.com/int-to-string-map/4, http://jsperf.com/cast-int-to-string-in-loop.
     *
     * The StringToIntMap is mainly used to convert string to const enum. For example:
     * const enum Fruit {
     *   Unknown = 0,
     *   Apple = 1,
     *   Banana = 2,
     *   Max = 3
     * }
     * var stringToIntMap = utilities.getStringToIntMap(Fruit.Max);
     * strictEqual(stringToIntMap["1"], Fruit.Apple);
     * strictEqual(stringToIntMap["2"], Fruit.Banana);
     *
     * @param requiredMaxInteger The required max integer.
     * @returns The object have one to one mapping between the string and the corresponding integer. e.g. {"0":0,"1":1,"2":2,"3":3,"4":4, ... }.
     */
    export function getIntToStringMap(requiredMaxInteger: number): string[] {
        validateRequiredMaxInteger(requiredMaxInteger);
        return intToStringMap;
    }

    /**
     * Get a readonly map that is a faster alternative to cast a small and non-negative integer to string.
     * - Doesn't support negative integer since the performance is significantly decreased for negative integer.
     * - The JSperf links: http://jsperf.com/parseint-vs-map-lookup/2, http://jsperf.com/parseint-vs-map-lookup-2
     *
     * The intToStringMap is mainly used to convert const enum to string. For example:
     * const enum Fruit {
     *     Unknown = 0,
     *     Apple = 1,
     *     Banana = 2,
     *     Max = 3
     * }
     *
     * var stringToIntMap = utilities.getStringToIntMap(Fruit.Max);
     * strictEqual(intToStringMap[Fruit.Unknown], "0");
     * strictEqual(intToStringMap[Fruit.Apple], "1");
     *
     * @param requiredMaxInteger The required max integer.
     * @returns The array to have increment integer in string representation. e.g. ["0","1","2","3","4", ...].
     */
    export function getStringToIntMap(requiredMaxInteger: number): StringMap<number> {
        validateRequiredMaxInteger(requiredMaxInteger);
        return stringToIntMap;
    }

    /**
     * Makes a shallow clone of the source object with the same prototype and rebinds all functions
     * on the clone to use the source object as 'this'.
     *
     * @param object The source object.
     * @return The cloned object.
     */
    export function cloneAndRebindFunctions<T>(object: T): T {
        const clone = ObjectGlobal.create(ObjectGlobal.getPrototypeOf(object));
        for (const key in object) {
            const value = (<any>object)[key];
            if (isTypeOf(value, functionType)) {
                clone[key] = value.bind(object); // This preserves ko_isObservable(value).
            } else if (object_hasOwnProperty(object, key)) {
                clone[key] = value;
            }
        }
        return clone;
    }

    function toLowerCaseOnlyWithValue(value: string): string {
        return value && value.toLowerCase();
    }

    /**
     * Takes a value and lower cases recursively.
     * For a string, returns the lower case string (non-value remains non-value).
     * For an object, recursively converts all string properties to lower case strings, including arrays of values.
     * For an array, returns an array with all string values converted to lower case.
     *
     * @param source The source value to make lower case.
     * @returns The lower case value.
     */
    export function lowerCaseAllStrings(source: any): any {
        if (source) {
            const type = typeof source;
            if (type === "string") {
                return toLowerCaseOnlyWithValue(source);
            } else if (Array.isArray(source)) {
                return source.map((arrayValue: any) => lowerCaseAllStrings(arrayValue));
            } else if (type === "object") {
                const sourceAsStringMap = <any>source;
                MsftSme.forEachKey(sourceAsStringMap, function (key) {
                    sourceAsStringMap[key] = lowerCaseAllStrings(sourceAsStringMap[key]);
                });
                return sourceAsStringMap;
            }
        }
        return source;
    }

    /**
     * Enum of environment mode.
     */
    export const enum EnvironmentMode {
        NotUse,
        LoadEmbedded,
        Load
    }

    /**
     * Side load setting interface.
     */
    export interface SideLoad {
        origin: string;
    }

    const sideLoadKey = 'MsftSme.SideLoad@';

    /**
     * Read all side-loading settings on current loaded domain.
     */
    function sideLoadRead(): { [name: string]: SideLoad } {
        // Read side-load data from localStorage
        let global = window;
        let length = LocalStorageHandler.getLength(global);
        let keys: string[] = [];
        for (let index = 0; index < length; index++) {
            let key = LocalStorageHandler.getKey(index, global);
            if (key.startsWith(sideLoadKey)) {
                keys.push(key);
            }
        }

        let data: { [name: string]: SideLoad } = {};
        for (let key of keys) {
            let item = <SideLoad>JSON.parse(LocalStorageHandler.getItem(key, global) ?? '{}');

            // trim last "/"
            if (item.origin[item.origin.length - 1] === '/') {
                item.origin = item.origin.substring(0, item.origin.length - 1);
            }

            data[item.origin] = item;
        }

        // Read sideload data from 'sideload' url parameter
        let sideloadParam = getLocationSearchParameter('sideload');

        // if we found the parameter and it has a value, then process the sideload data
        if (sideloadParam && sideloadParam.value) {
            // sideload parameter should be a comma seperated list
            sideloadParam.value.split(',')
                // add sidloads to data, overriding local storage
                .forEach(origin => {
                    // trim last "/"
                    if (origin[origin.length - 1] === '/') {
                        origin = origin.substring(0, origin.length - 1);
                    }

                    data[origin] = { origin };
                });
        }

        return data;
    }

    /**
     * Override environment setting with side-loading setting on current loaded domain.
     * - update information to local storage key and overridden when loading the manifest.
     * - use sideLoadReset to reset all sideLoading settings.
     *
     * @param originUri the origin url of the module.
     */
    export function sideLoad(originUri?: string): { [name: string]: SideLoad } {
        if (arguments.length > 1) {
            throw new Error(`Incorrect syntax for side loading. Please use 'MsftSme.sideload(<origin>);' where '<originUri>' is similar to 'http://localhost:4201'. The new syntax will load any module from the manifest at <originUri>/manifest.json at runtime.`);
        }

        if (originUri) {
            if (!['http://', 'https://'].some(prefix => originUri.startsWith(prefix))) {
                throw new Error(`Incorrect syntax for side loading. To ensure cross origin sideloads support, please begin your sideload origin with "http://" or "https://". Ex. "MsftSme.sideload('http://${originUri}')"`);
            }

            let item = <SideLoad>{
                origin: originUri
            };
            LocalStorageHandler.setItem(sideLoadKey + originUri, JSON.stringify(item), global);
            let data: { [name: string]: SideLoad } = {};
            data[originUri] = item;
            return data;
        }

        return sideLoadRead();
    }

    /**
     * Reset all side-loading settings on current loaded domain.
     */
    export function sideLoadReset(): void {
        let global = window;
        let length = LocalStorageHandler.getLength(global);
        let keys: string[] = [];
        for (let index = 0; index < length; index++) {
            let key = LocalStorageHandler.getKey(index, global);
            if (key.startsWith(sideLoadKey)) {
                keys.push(key);
            }
        }

        for (let key of keys) {
            LocalStorageHandler.removeItem(key, global);
        }
    }

    const consoleDebugKey = 'MsftSme.ConsoleDebug';

    /**
     * Read debug console setting.
     */
    function consoleDebugRead(): number {
        // first check for a query parameter that tells us what debug level to use
        let consoleDebugParam = getLocationSearchParameter('consoledebug');

        // if we found the parameter and it has a value, then process that as our sideload setting data
        if (consoleDebugParam && consoleDebugParam.value) {
            try {
                let level = parseInt(consoleDebugParam.value);
                return level;
            } catch (ex) {
                console.error(`Error reading "consoleDebug" parameter: ${ex.message}`);
            }
        }

        // then we fallback to what is saved in localStorage
        let data = <{ level: number }>JSON.parse(
            LocalStorageHandler.getItem(consoleDebugKey) ?? '{}', global);
        if (data && data.level) {
            return data.level;
        }

        // fallback again to whatever was passed into the Init call
        let smeWindow = (<SMEWindow>global);
        if (smeWindow && smeWindow.MsftSme && smeWindow.MsftSme.Init) {
            return smeWindow.MsftSme.Init.logLevel;
        }

        // return null if not set yet. using default see at core-enviromnent.
        return null;
    }

    /**
     * Override environment setting with side-loadig setting on current loaded domain.
     * - update information to local storage key and overriden when loading the manifest.
     * - use sideLoadReset to reset all sideLoading settings.
     *
     * @param level the debug level. 1:Critical, 2:Error, 3:Warning, 4:Success, 5:Informational, 6:Verbose, 7:Debug.
     *
     */
    export function consoleDebug(level?: number): number {
        if (level) {
            // console.log('1:Critical, 2:Error, 3:Warning, 4:Success, 5:Informational, 6:Verbose, 7:Debug');
            LocalStorageHandler.setItem(consoleDebugKey, JSON.stringify({ level: level }), global);
            (<SMEWindow>global).MsftSme.Init.logLevel = level;
            return level;
        }

        return consoleDebugRead();
    }

    /**
     * Reset all side-loading settings on current loaded domain.
     */
    export function consoleDebugReset(): void {
        LocalStorageHandler.removeItem(consoleDebugKey, global);
    }

    // #region Performance Profile management
    /**
     * Performance Profile management.
     */
    const performanceProfileStorageKey = '@msft-sme/shell:performanceProfile';

    export function getPerformanceProfile(): boolean {
        const profile = LocalStorageHandler.getItem(performanceProfileStorageKey);
        return profile === "1";
    }

    export function setPerformanceProfile(profile: boolean) {
        if (profile) {
            LocalStorageHandler.setItem(performanceProfileStorageKey, "1");
        } else {
            LocalStorageHandler.removeItem(performanceProfileStorageKey);
        }
    }

    // #endregion // Performance Profile management

    // #region Developer guide management
    /**
     * Developer guide management
     */
    const developerGuideStorageKey = '@msft-sme/shell:developerGuide';
    const developerGuideExperimentKey = 'msft.sme.shell.devguide';

    export function getDeveloperGuide(): boolean {
        const experiments = this.experiments();
        // If they have the developer guide experiment key, remove and set storage key to true
        if (experiments.some(experiment => experiment === developerGuideExperimentKey)) {
            const filteredExperiments = experiments.filter(experiment => experiment !== developerGuideExperimentKey);
            // remove experiment key
            this.experiments(filteredExperiments);
            // set storage key
            this.setDeveloperGuide(true);
            return true;
        } else {
            const developerGuide = LocalStorageHandler.getItem(developerGuideStorageKey);
            return developerGuide === "1";
        }
    }

    export function setDeveloperGuide(developerGuide: boolean) {
        if (developerGuide) {
            LocalStorageHandler.setItem(developerGuideStorageKey, "1");
        } else {
            LocalStorageHandler.removeItem(developerGuideStorageKey);
        }
    }

    // #endregion // Developer guide management

    /**
     * Constants for experiment flags
     */
    const experimentsKey = 'MsftSme.Experiments';
    const experimentsSplitChar = ',';

    /**
     * Read experiment setting.
     */
    function experimentsRead(): string[] {
        // first check for a query parameter that tells us what debug level to use
        let experimentsParam = getLocationSearchParameter('experiments');

        // if we found the parameter and it has a value, then process that as our sideload setting data
        if (experimentsParam && experimentsParam.value) {
            try {
                return experimentsParam.value.split(experimentsSplitChar);
            } catch (ex) {
                console.error(`Error reading "experiments" parameter: ${ex.message}`);
            }
        }

        // then we fallback to what is saved in localStorage
        let data = <string>LocalStorageHandler.getItem(experimentsKey);
        if (!MsftSme.isNullOrWhiteSpace(data)) {
            return data.split(experimentsSplitChar);
        }

        // fallback again to whatever was passed into the Init call
        let smeWindow = (<SMEWindow>global);
        if (smeWindow && smeWindow.MsftSme && smeWindow.MsftSme.Init) {
            return smeWindow.MsftSme.Init.experiments;
        }

        // return empty array if not set yet.
        return [];
    }

    /**
     * Override environment setting with experiment setting on current loaded domain. requires reload to really be effective     *
     * @param value The experiments to turn on. Each entry should be in the format: <extension name>.<key>
     */
    export function experiments(value?: string[]): string[] {
        if (Array.isArray(value)) {
            LocalStorageHandler.setItem(experimentsKey, value.join(experimentsSplitChar), global);
            (<SMEWindow>global).MsftSme.Init.experiments = value;
            return value;
        }

        return experimentsRead();
    }

    /**
     * Reset all experiment settings on current loaded domain.*
     */
    export function experimentsReset(): void {
        LocalStorageHandler.removeItem(experimentsKey, global);
    }

    /**
     * Returns true if the given experiment key is set relative to the current module or to shell
     * @param key the experiment key to check. This is without the module name. i.e. msft.sme.shell.experiment should be checked with isExperimentEnabled('experiment')
     * @param shellExperiment if true, indicates that we should check for global shell experiments instead of local module experiments. Defaults to false
     */
    export function isExperimentEnabled(key: string, shellExperiment: boolean = false): boolean {
        let moduleName = shellExperiment ? MsftSme.self().Environment.shell.name : MsftSme.self().Environment.name;
        let experimentKey = `${moduleName}.${key}`;
        return MsftSme.experiments().some(x => x.toLowerCase() === experimentKey.toLowerCase());
    }

    /**
     * Returns true if the given experiment key is set.
     * @param key the experiment key to check.

     */
    export function isExperimentEnabledRaw(key: string): boolean {
        const lowerCaseKey = key.toLowerCase();
        return MsftSme.experiments().some(x => x.toLowerCase() === lowerCaseKey);
    }

    /**
     * Gets the localized strings initialized by localization manager. The LocalizationManager should have
     * been used to get the localized strings.
     *
     * @returns an object containing all the localized strings, or null if noe localized strings have been fetched yet
     */
    export function getStrings<T>(): T {
        if (!global.MsftSme.Resources || !global.MsftSme.Resources.strings) {
            throw new Error('Unable to access localized resource strings.');
        }

        return <T>MsftSme.self().Resources.strings;
    }

    /**
     * @deprecated Use MsftSme.getStrings<T>() instead.
     *
     * Gets the localized strings initialized by localization manager. The LocalizationManager should have
     * been used to get the localized strings.
     *
     * @returns an object containing all the localized strings, or null if noe localized strings have been fetched yet
     */
    export function resourcesStrings<T>(): T {
        if (!global.MsftSme.Resources || !global.MsftSme.Resources.strings) {
            throw new Error('Unable to access localized ResourcesStrings data.');
        }

        return <T>global.MsftSme.Resources.strings;
    }

    /**
     * Gets current session identification.
     * Within the same browser session, the session ID is the same on shell and all modules.
     */
    export function sessionId(): string {
        let global: MsftSme.SMEWindow = <any>window;
        return global.MsftSme.Init.sessionId;
    }

    /**
     * Gets the self object of global MsftSme.
     */
    export function self(): MsftSme.MsftSmeWindowContext {
        let self = (<MsftSme.SMEWindow><any>window).MsftSme;
        if (!self.Host) {
            /* IsElectron and IsWeb are opposites today, but may not always be. (Example,: if we ever went with a UWP or Ibiza approach. )
            think of it this way:
            "electron" is the reference to electron or null
            "isElectron" is a shortcut to know if we are running in an electron context
            "isWeb" is a shortcut to knowing if we are running in the default "web" context. */
            let electron: MsftSme.MsftSmeElectron = window['require'] ? window['require']('electron') : null;
            self.Host = {
                isElectron: !!electron,
                isWeb: !electron,
                electron: electron
            };
        }
        return self;
    }

    /**
     * Returns the window that is hosting the current window or null if the current window is not hosted.
     */
    export function getHostWindow(): Window {
        if (window.opener) {
            return window.opener;
        }
        if (window.parent !== window.self) {
            return window.parent;
        }
        if (window.top !== window.self) {
            return window.top;
        }
        return null;
    }

    /**
     * Returns true if the current window is the top window. Otherwise returns false
     */
    export function isHostedWindow(): boolean {
        return !MsftSme.isNullOrUndefined(MsftSme.getHostWindow());
    }

    /**
     * returns true if the current window is the shell instance.
     */
    export function isShell(): boolean {
        return MsftSme.self().Init.isShell;
    }

    /**
     * returns true if the current window is the an extension instance.
     */
    export function isExtension(): boolean {
        return !MsftSme.isShell();
    }

    /**
     * returns the entry point type string.
     * - 'solution'
     * - 'tool'
     * - 'service'
     * - 'settingsForm'
     * - 'worker'
     * - 'dialog'
     * - 'snapIn'
     */
    export function entryPointType(): string {
        return MsftSme.self().Init.entryPointType;
    }

    /**
     * Writes helpful debug information to the console
     */
    export function help(): void {
        console.log(`
Available Debug Commands:

Get/Set The log level:
    MsftSme.consoleDebug()                  -- Gets the current logging level
    MsftSme.consoleDebugReset()             -- Restores the default console log level
    MsftSme.consoleDebug(level: number)   -- Sets the current logging level

    Log Levels
        1: Critical
        2: Error
        3: Warning
        4: Success
        5: Informational
        6: Verbose
        7: Debug

Get/Set sideload setting
    MsftSme.sideload()                      -- Gets the current sideload settings
    MsftSme.sideloadReset()                 -- Removes all sideload settings
    MsftSme.sideload(origin: string)        -- Adds a new sideload settings to the origin uri where a module is hosted.

Get/Set experiment flags:
    MsftSme.experiments()                   -- Gets the currently enabled experiment keys
    MsftSme.experimentsReset()              -- Removes all enabled experiment keys
    MsftSme.experiments(keys: string[])     -- Enables a set of experiment keys.


Get Environmental Information
    MsftSme.listVersions()                  -- list the versions of all ux modules currently installed
    MsftSme.self()                          -- Gets the global environment configuration.

`
        );
    }

    /**
     * List the versions of all UX components in windows admin center
     */
    export function listVersions(): void {
        let environment = MsftSme.self().Environment;
        let result = {};
        result[environment.name] = environment.version;
        result = environment.modules.reduce((map, module) => {
            map[module.name] = module.version;
            return map;
        }, result);

        console.log(result);
    }

    /** array.ts */
    polyfill(Array, <ArrayPolyfills<any>>{
        concatUnique: function (other, predicate) {
            return union(this, other, predicate);
        },
        first: function (predicate, startIndex) {
            // Intentionally not using _.find here, since here if we don't find the element
            // we return null. In _.find when this happens we return undefined.
            let index = findIndex(this, predicate, startIndex);
            return index < 0 ? null : this[index];
        },
        firstIndex: function (predicate, startIndex) {
            return findIndex(this, predicate, startIndex);
        },
        last: function () {
            if (this.length < 1) {
                throw new Error("Cannot get the last element because the array is empty.");
            }

            return this[this.length - 1];
        },
        mapMany: function (selector: (value: any) => any[]): any[] {
            return mapMany(this, selector);
        },
        remove: function (item) {
            return remove(this, current => current === item);
        },
        stableSort: function (compare) {
            return stableSort(this, compare);
        },
        // Deprecated. Remove on or after 2016/02/01.
        toNumberMap: function (keySelector: (value: any) => number) {
            let ret: NumberMap<any> = [];
            (<any[]>this).forEach((value) => {
                ret[keySelector(value)] = value;
            });
            return ret;
        },
        unique: function (predicate) {
            return unique(this, predicate);
        }
    });

    /** string.ts */
    const namedFormatSpecifierRegex = /\{[a-zA-Z$_\d]*\}/g;
    const numberedFormatSpecifierRegex = /\{(\d+)\}/g;

    function format() {
        let restArgs = arguments,
            value = this;

        let matched = false,
            retVal: string;

        let isFormatObject = restArgs.length === 1 && restArgs[0] && typeof restArgs[0] === "object";
        let isFormatObjectWithTokenFormatter = restArgs.length === 2 && restArgs[0] && typeof restArgs[0] === "object" && (typeof restArgs[1] === "function" || restArgs[1] === null);
        let tokenFormatter = isFormatObjectWithTokenFormatter ? restArgs[1] : null;

        if (isFormatObject || isFormatObjectWithTokenFormatter) {
            let actualArg = restArgs[0];
            retVal = value.replace(namedFormatSpecifierRegex, (match: string) => {
                let name = match.substring(1, match.length - 1);
                if (actualArg.hasOwnProperty(name)) {
                    matched = true;
                    let tokenValue = actualArg[name];
                    return tokenFormatter ? tokenFormatter(tokenValue) : tokenValue;
                } else {
                    return match;
                }
            });
        }

        // we get here in two cases:
        //    1. we don't have a format object
        //    2. we do have a format object but it's properties didn't match any of the named parameters.
        //       this often happens when developers write code like:
        //          try {
        //              ...
        //          } catch(err) {
        //              log("abc: {0}".format(err));
        //          }
        //       in this scenario also we want to match by number.
        //
        if (!matched) {
            retVal = value.replace(numberedFormatSpecifierRegex, (match: string, num: number) => {
                if (num < restArgs.length) {
                    let tokenValue = restArgs[num];
                    return tokenFormatter ? tokenFormatter(tokenValue) : tokenValue;
                } else {
                    return match;
                }
            });
        }

        return retVal;
    }

    polyfill(String, <StringPolyfills>{
        format: format,
        localeCompareIgnoreCase: function (value, locales, options) {
            return localeCompareIgnoreCase(this, value, locales, options);
        },
        replaceAll: function (searchValue, replaceValue) {
            return replaceAll(this, searchValue, replaceValue);
        },
        replaceMany: function (replacementMap) {
            return replaceMany(this, replacementMap);
        },
        repeat: function (count) {
            return repeat(this, count);
        },
        startsWith: function (searchString, position) {
            return startsWith(this, searchString, position);
        },
        endsWith: function (searchString, position) {
            return endsWith(this, searchString, position);
        }
    }, /* force */ true);

    global.MsftSme = MsftSme;
}
